import { v4 as uuidv4 } from "uuid";
export class CumulativeTimeReportEntryModel {
    constructor() {
        this.id = uuidv4();
        this.startTime = null;
        this.endTime = null;
        this.description = "";
        this.employeeId = null;
        this.employeeName = "";
        this.startTimeTzFormatted = "";
        this.endTimeTzFormatted = "";
        this.startTimeAsString = "";
        this.totalTimeTakenInTaskInHours = "";
        this.totalTime = "";
        this.totalTimeInSeconds = 0;
        this.projectDisplayString = "";
        this.taskDisplayString = "";
        this.taskDescription = "";
        this.totalTimeTakenInTask = "";
    }
}
export default class TimeReport extends CumulativeTimeReportEntryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
